import type { FaireProductEntity } from "../../entity_types/product";

export const p_g53247r534: FaireProductEntity = {
  token: "p_g53247r534",
  type: "product",
  name: '4" Halloween Glitter Jelly Dumpling - Black Steamer',
  brandToken: "b_acm3c78p2p",
  brandName: "Handee Products (HPC)",
  imageUrl:
    "https://cdn.faire.com/fastly/fbb10ed67d0b05cca1dfca386cc372d2d76f618c9480eb6fd3687a1abf9fba61.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4c7cb8a805318f5e25a195bcfa81924c6dfcb6d5a6a445281a9859b1782287bb.jpeg",
    "https://cdn.faire.com/fastly/35ac8d320bf3008aaacffae0f7b8bdcc984315d98828ab13967373244fd14498.png",
  ],
  priceDollars: 5.95,
  description:
    'Grab these Limited Edition Halloween Mystery Dumplings while supplies last.\nWith it\'s jelly glitter filling and 4 adorable Halloween themed Dumplings to collect these are sure to be a hit this Halloween season!\n\n- Come in a black steamer container\n- 4 Assorted Styles + 1 Rare Style\n- 3.5" dumpling in 4" container\n- Collect them all!\n\n- Can you find the rare Glow in the Dark Ghost Dumpling???\n\n\nAs with all our products, our dumplings are stringently tested to adhere to the applicable toy safety standards and ensure our products are safe for children and adults alike.',
  tags: [],
  msrpDollars: 13.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:33.121Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
